const TEMPLATES = [
  { key: 'story', title: 'Story funnel', desc: 'Personal narrative → stakes → discovery → soft offer. Best for Meta cold traffic.' },
  { key: 'problem_solution', title: 'Problem-Solution funnel', desc: 'Name the specific pain → mechanism → product. Best for search + retargeting.' },
  { key: 'list', title: 'List / value funnel', desc: '"3 things that…" editorial format. Product is item 3 of 5. Best for Pinterest & Reddit.' },
  { key: 'curiosity', title: 'Curiosity funnel', desc: 'Open loop question → evidence → resolution. Best for top-of-funnel.' },
  { key: 'creator', title: 'Creator funnel', desc: 'Founder voice advertorial. Looks like a Substack post. Best for Reddit paid traffic.' },
];

export default function Funnels() {
  return (
    <>
      <h2 className="page-title">Funnel Builder</h2>
      <p className="page-sub">Built-in templates. Publish as Shopify theme extensions or standalone pages.</p>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 16 }}>
        {TEMPLATES.map((t) => (
          <div key={t.key} className="card card-padded">
            <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 4 }}>{t.title}</div>
            <div style={{ fontSize: 12, color: 'var(--text-sub)', marginBottom: 12, minHeight: 60 }}>{t.desc}</div>
            <button className="btn btn-small">Use template</button>
          </div>
        ))}
      </div>
    </>
  );
}
